import React from "react";
import CustomizedDialogs from "./contact";
import GetInTouch from "./getintouch";
function ContactUs () {
    return(
        <div>
                <CustomizedDialogs>
                    <GetInTouch />
                </CustomizedDialogs>
        </div>
    )
}

export default ContactUs